import { useEffect, useState } from 'react';
import axios from 'axios';
import { ITopic } from 'app/shared/model/topic.model';

/** Top level topics (the ones without a parent), used as parents for sub topics. */
export const useParentTopics = (): ITopic[] => {
  const [parents, setParents] = useState<ITopic[]>([]);

  useEffect(() => {
    axios
      .get<ITopic[]>('api/topics?parentId.specified=false&page=0&size=100&sort=name,asc')
      .then(response => setParents(response.data || []))
      .catch(() => setParents([]));
  }, []);

  return parents;
};
